function getWrapperWidth(size) {
    const width = {
        0: 'width: 40%;',
        1: 'width: 70%;',
        2: 'width: 100%;'
    };
    return width[size] || '';
}

export default getWrapperWidth;
